module.exports = __webpack_public_path__ + "static/media/github.029f02af.svg";